export const NFTCONTRACT = "0x7292114A59d9D8b8c975E2059d6D995E5fdC2D10";
export const PSALECONTRACT = "0x9Bc7e260241A5CCF6eAFE92E2c273e9433188FBf";
export const polygonscanapi = "https://api.polygonscan.com/api";
export const moralisapi = "https://deep-index.moralis.io/api/v2/";
